import React, { useState, useEffect } from "react";
import axios from "axios";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import EditToken from "./EditToken";
import AddNewToken from "./AddNewToken";
import { AiOutlineCloseCircle } from "react-icons/ai";
import IsLoading from "../IsLoading";
import TokenDetails from "./TokenDetails";
import IconBin from "../../assets/pictos/IconBin";
import IconUpdate from "../../assets/pictos/IconUpdate";
import IconEdit from "../../assets/pictos/IconEdit";
import IconLink from "../../assets/pictos/IconLink";
import { buildApiUrl, fetchZkTransfers } from '../../config/api';

const ProfileReceived = (userData) => {
  const [originalItems, setOriginalItems] = useState([]);
  const [tableItems, setTableItems] = useState([]);
  const [selectedToken, setSelectedToken] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [notifModal, setNotifModal] = useState({ isOpen: false, message: '', color: '' });
  const [sortBy, setSortBy] = useState("ticker");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const tokensPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [fetchLivePrices, setFetchLivePrices] = useState([]);
  const [showProjectDetails, setShowProjectDetails] = useState(false);
  const [showAddNewToken, setShowAddNewToken] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");

  const handleShowProjectDetails = (item) => {
    setShowProjectDetails(!showProjectDetails);
    setSelectedToken(item);
  };

  const handleShowAddNewToken = () => {
    console.log("clicked")
    setShowAddNewToken(!showAddNewToken);
    console.log(showAddNewToken)
  };

  const fetchPricesFunction = async (ticker) => {
    try {
      const response = await axios.get(
        `https://api.coingecko.com/api/v3/simple/price?ids=${ticker}&vs_currencies=USD`
      );
      const usdValue = response.data[ticker.toLowerCase()].usd;
      setFetchLivePrices((prevPrices) => ({
        ...prevPrices,
        [ticker]: usdValue,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const getTokensData = async () => {
    setLoading(true);
    const response = await axios.get(
      "https://cryptools-server-production.up.railway.app/api/user",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const tokens = response.data.user.monitoredToken;
    const tokensData = [];
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      const tokenData = {
        id: token._id,
        ticker: token.ticker,
        blockchain: token.blockchain,
        to_receive: parseFloat(token.to_receive.toString().replace(",", ".")),
        received: token.received,
        logo: token.logo,
        contractAddresses: token.contract,
        receivedAmount: token.receivedAmount,
        lastUpdate: token.lastUpdate,
        decimals: token.decimals,
        launchpad: token.launchpad,
        claimPortal: token.claimPortal,
        paymentTransaction: token.paymentTransaction,
        isOver: token.isOver,
        vestingDate: new Date(token.vestingDate)
          .toLocaleDateString("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/\//g, "-"),
      };
      tokensData.push(tokenData);
    }
    setTableItems(tokensData);
    setOriginalItems(tokensData);
    setLoading(false);
  };

  // const BSCKEY = process.env.REACT_APP_BSC_API_KEY;
  // const ETHKEY = process.env.REACT_APP_ETH_API_KEY;
  // const FTMKEY = process.env.REACT_APP_FTM_API_KEY;
  // const MATICKEY = process.env.REACT_APP_MATIC_API_KEY;
  // const AVAXKEY = process.env.REACT_APP_AVAX_API_KEY;
  // const ARBIKEY = process.env.REACT_APP_ARB_API_KEY;

  useEffect(() => {
    getTokensData();
  }, []);

  const updateAllTokens = async () => {
    const updatedTokens = [];
    const changedTokens = [];

    for (const token of tableItems) {
      const { contractAddresses } = token;
      const blockchain = token.blockchain;
      const address = `${userData.userData.user.address}`;
      const addressLowerCase = address.toLowerCase();

      let apiUrl = "";
      if (blockchain === "binance-smart-chain") {
        apiUrl = buildApiUrl('BSC', contractAddresses["binance-smart-chain"], address);
      } else if (blockchain === "ethereum") {
        apiUrl = buildApiUrl('ETH', contractAddresses["ethereum"], address);
      } else if (blockchain === "fantom") {
        apiUrl = buildApiUrl('FTM', contractAddresses["fantom"], address);
      } else if (blockchain === "polygon-pos") {
        apiUrl = buildApiUrl('MATIC', contractAddresses["polygon-pos"], address);
      } else if (blockchain === "avalanche") {
        apiUrl = buildApiUrl('AVAX', contractAddresses["avalanche"], address);
      } else if (blockchain === "arbitrum") {
        apiUrl = buildApiUrl('ARB', contractAddresses["arbitrum-one"], address);
      } else if (blockchain === "base") {
        apiUrl = buildApiUrl('BASE', contractAddresses["base"], address);
      }

      try {
        const response = await axios.get(apiUrl);
        let newReceivedAmount = 0; // Renommé pour clarifier
        let blockchain = token.blockchain;
        if (blockchain === "arbitrum") {
          blockchain = "arbitrum-one";
        }
        const decimals = token.decimals[blockchain].decimal_place;
        for (let i = 0; i < response.data.result.length; i++) {
          const transaction = response.data.result[i];
          const transactionToLowerCase = transaction.to.toLowerCase();
          if (transactionToLowerCase === addressLowerCase) {
            const contractAddress = transaction.contractAddress;
            const amount = transaction.value / Math.pow(10, decimals);
            if (contractAddress === contractAddresses[blockchain]) {
              newReceivedAmount += amount;
            }
          }
        }

        // Vérifier s'il y a une différence
        if (token.receivedAmount !== newReceivedAmount) {
          changedTokens.push({
            name: token.name,
            blockchain: token.blockchain,
            oldAmount: token.receivedAmount,
            newAmount: newReceivedAmount
          });
        }

        token.receivedAmount = newReceivedAmount;
        token.lastUpdate = new Date();
        updatedTokens.push(token);
        updateReceivedAmount(token.id, newReceivedAmount, token.lastUpdate);
      } catch (error) {
        console.log(error);
      }
      await new Promise((resolve) => setTimeout(resolve, 200));
    }

    setTableItems(updatedTokens);

    // Logger les tokens qui ont changé
    if (changedTokens.length > 0) {
      console.log("Tokens with changes:");
      changedTokens.forEach(token => {
        console.log(`${token.name} (${token.blockchain}): ${token.oldAmount} -> ${token.newAmount}`);
      });
    } else {
      console.log("No changes detected in any tokens.");
    }
  };

  const updateSingleToken = (token) => {
    const { contractAddresses } = token;
    const blockchain = token.blockchain;
    const address = `${userData.userData.user.address}`;
    const addressLowerCase = address.toLowerCase();
  
    let blockchainKey = blockchain;
    if (blockchain === "arbitrum") {
      blockchainKey = "arbitrum-one";
    } else if (blockchain === "zksync-era") {
      blockchainKey = "zksync";
    }
  
    const tokenContract = contractAddresses[blockchainKey];
  
    // Cas spécial pour zkSync Era
    if (blockchain === "zksync-era") {
      fetchZkTransfers(address, tokenContract)
        .then((result) => {
          token.receivedAmount = result.receivedAmount;
          token.lastUpdate = result.lastUpdate;
          setTableItems([...tableItems]);
          updateReceivedAmount(token.id, result.receivedAmount, result.lastUpdate);
          
          setNotifModal({ isOpen: true, message: 'Token successfully updated', color: 'green' });
          setTimeout(() => {
            setNotifModal({ isOpen: false, message: '', color: '' });
          }, 4000);
        })
        .catch((error) => {
          console.log(error);
          const errorMessage = error.response?.data?.result || 'An error occurred while updating data';
          setNotifModal({ isOpen: true, message: errorMessage, color: 'red' });
          setTimeout(() => {
            setNotifModal({ isOpen: false, message: '', color: '' });
          }, 6000); // Plus de temps pour lire le message d'erreur
        });
      return;
    }
  
    // Pour toutes les autres blockchains
    let apiUrl = '';
    if (blockchain === "binance-smart-chain") {
      apiUrl = buildApiUrl('BSC', tokenContract, address);
    } else if (blockchain === "ethereum") {
      apiUrl = buildApiUrl('ETH', tokenContract, address);
    } else if (blockchain === "fantom") {
      apiUrl = buildApiUrl('FTM', tokenContract, address);
    } else if (blockchain === "polygon-pos") {
      apiUrl = buildApiUrl('MATIC', tokenContract, address);
    } else if (blockchain === "avalanche") {
      apiUrl = buildApiUrl('AVAX', tokenContract, address);
    } else if (blockchain === "arbitrum-one") {
      apiUrl = buildApiUrl('ARB', tokenContract, address);
    } else if (blockchain === "base") {
      apiUrl = buildApiUrl('BASE', tokenContract, address);
    }
  
    axios.get(apiUrl)
      .then((response) => {
        // Vérifier si l'API retourne une erreur même avec status 200
        if (response.data.status === "0" && response.data.message === "NOTOK") {
          throw new Error(response.data.result);
        }
  
        let receivedAmount = 0;
        let decimals;
        if (token.decimals && token.decimals[blockchainKey] && token.decimals[blockchainKey].decimal_place) {
          decimals = token.decimals[blockchainKey].decimal_place;
        } else if (response.data.result && response.data.result.length > 0) {
          decimals = parseInt(response.data.result[0].tokenDecimal) || 18;
        } else {
          decimals = 18;
        }
  
        for (let i = 0; i < response.data.result.length; i++) {
          const transaction = response.data.result[i];
          const transactionToLowerCase = transaction.to.toLowerCase();
          
          if (transactionToLowerCase === addressLowerCase) {
            const contractAddress = transaction.contractAddress.toLowerCase();
            
            if (contractAddress === contractAddresses[blockchainKey].toLowerCase()) {
              const amount = parseFloat(transaction.value) / Math.pow(10, decimals);
              receivedAmount += amount;
            }
          }
        }
  
        setNotifModal({ isOpen: true, message: 'Token successfully updated', color: 'green' });
        setTimeout(() => {
          setNotifModal({ isOpen: false, message: '', color: '' });
        }, 4000);
        
        token.receivedAmount = receivedAmount;
        token.lastUpdate = new Date();
        setTableItems([...tableItems]);
        updateReceivedAmount(token.id, receivedAmount, token.lastUpdate);
      })
      .catch((error) => {
        console.log(error);
        
        // Extraire le message d'erreur de l'API si disponible
        let errorMessage = 'An error occurred while updating data';
        
        if (error.message) {
          errorMessage = error.message;
        } else if (error.response?.data?.result) {
          errorMessage = error.response.data.result;
        }
        
        setNotifModal({ isOpen: true, message: errorMessage, color: 'red' });
        setTimeout(() => {
          setNotifModal({ isOpen: false, message: '', color: '' });
        }, 6000); // Plus de temps pour lire le message d'erreur
      });
  };

  const handleEditClick = (item) => {
    setSelectedToken(item);
    setShowEditModal(!showEditModal);
  };

  useEffect(() => {
    if (showAddModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showAddModal, showProjectDetails]);

  const deleteToken = async (token) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this token?"
    );

    if (!confirmed) {
      return;
    }

    try {
      await axios.delete(
        `https://cryptools-server-production.up.railway.app/api/user/deleteToken/${token.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Token deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const updateReceivedAmount = (
    tokenId,
    receivedAmount,
    lastUpdate,
    vestingDate
  ) => {
    axios
      .put(
        `https://cryptools-server-production.up.railway.app/api/user/editToken/${tokenId}`,
        // `http://localhost:4000/api/user/editToken/${tokenId}`,
        { receivedAmount, lastUpdate },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const totalPages = Math.ceil(tableItems.length / tokensPerPage);

  function generatePageNumbers() {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;

    if (totalPages <= maxPageNumbersToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const middlePage = Math.floor(maxPageNumbersToShow / 2);

      let startPage = currentPage - middlePage;
      let endPage = currentPage + middlePage;

      if (startPage <= 0) {
        startPage = 1;
        endPage = maxPageNumbersToShow;
      } else if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxPageNumbersToShow + 1;
      }

      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push("...");
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push("...");
        }
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  }

  function handleNextPageMobile() {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  }

  const handlePrevPageMobile = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClearSearchTerm = () => {
    setSearchTerm("");
  };

  const handleEndedVesting = () => {
    setSortBy("date");
    setSortOrder("desc");
    const endedVesting = originalItems.filter((item) => {
      const today = new Date();
      const vestingDate = new Date(item.vestingDate);
      const receivedPercentage = item.receivedAmount / item.to_receive;
      return (today > vestingDate && receivedPercentage < 0.97) && !item.isOver;
    });
    setSelectedTab("ended-vesting");
    setTableItems(endedVesting);
    setCurrentPage(1);
  };

  const selectedLaunchpad = (launchpad) => {
    setSortBy("ticker");
    setSortOrder("asc");
    const selectedLaunchpad = originalItems.filter((item) => {
      return item.launchpad === launchpad;
    });
    setSelectedTab("launchpad");
    setTableItems(selectedLaunchpad);
    setCurrentPage(1);
  };

  const handleLaunchpadChange = (event) => {
    const launchpad = event.target.value;
    if (launchpad === "all") {
      setTableItems(originalItems);
      setCurrentPage(1);
    } else {
      selectedLaunchpad(launchpad);
    }
  };

  const handle50Received = () => {
    const filteredItems = originalItems.filter((item) => {
      const receivedPercentage = item.receivedAmount / item.to_receive;
      return receivedPercentage >= 0.5 && receivedPercentage < 0.97;
    });
    setSortBy("pourcentage");
    setSortOrder("asc");
    setSelectedTab("50");
    setTableItems(filteredItems);
    setCurrentPage(1);
  };

  const handleShowAll = () => {
    setSortBy("ticker");
    setSortOrder("asc");
    setSelectedTab("all");
    setTableItems(originalItems);
    setCurrentPage(1);
  };

  const handleEnded = () => {
    const ended = originalItems.filter((item) => {
      return item.receivedAmount / item.to_receive >= 0.97 || item.isOver;
    });
    setTableItems(ended);
    setSelectedTab("ended");
    setCurrentPage(1);
  };

  const handleLiveDeals = () => {
    const liveDeals = originalItems.filter((item) => {
      const today = new Date();
      const vestingDate = new Date(item.vestingDate);
      const receivedPercentage = item.receivedAmount / item.to_receive;
      return today < vestingDate && receivedPercentage < 0.97 && !item.isOver;
    });
    setTableItems(liveDeals);
    setSelectedTab("live");
    setCurrentPage(1);
  };

  useEffect(() => {
    handleLiveDeals();
  }, [originalItems]);

  const filteredItems = searchTerm
    ? tableItems.filter((item) => {
        const itemName = item.ticker ? item.ticker.toLowerCase() : "";
        return itemName.includes(searchTerm.toLowerCase());
      })
    : tableItems;

    

  const startIndex = (currentPage - 1) * tokensPerPage;
  const endIndex = startIndex + tokensPerPage;

  const sortedItems = filteredItems.sort((a, b) => {
    if (sortBy === "ticker") {
      return sortOrder === "asc"
        ? a.ticker.localeCompare(b.ticker)
        : b.ticker.localeCompare(a.ticker);
    } else if (sortBy === "blockchain") {
      return sortOrder === "asc"
        ? a.blockchain.localeCompare(b.blockchain)
        : b.blockchain.localeCompare(a.blockchain);
    } else if (sortBy === "toreceive") {
      return sortOrder === "asc"
        ? a.to_receive - b.to_receive
        : b.to_receive - a.to_receive;
    } else if (sortBy === "received") {
      return sortOrder === "asc"
        ? a.receivedAmount - b.receivedAmount
        : b.receivedAmount - a.receivedAmount;
    } else if (sortBy === "date") {
      return sortOrder === "asc"
        ? a.vestingDate.localeCompare(b.vestingDate)
        : b.vestingDate.localeCompare(a.vestingDate);
    } else {
      return sortOrder === "asc"
        ? (a.receivedAmount / a.to_receive) * 100 -
            (b.receivedAmount / b.to_receive) * 100
        : (b.receivedAmount / b.to_receive) * 100 -
            (a.receivedAmount / a.to_receive) * 100;
    }
  });

  const paginatedItems = sortedItems.slice(startIndex, endIndex);

  // !loading && <IsLoading />;

  return (
    <div>
        <AddNewToken tableItems={tableItems} isVisible={showAddNewToken} onClose={() => setShowAddNewToken(false)} />
        {notifModal.isOpen && (
        <div className={`bg-${notifModal.color}-50 border-t-4 border-${notifModal.color}-500 rounded-b text-${notifModal.color}-900 px-4 py-3 shadow-md w-fit fixed right-10 top-[8rem] z-50`} role="alert">
          <div className="flex">
            <div className="py-1">
              <svg className="mr-4 w-6 h-6 text-teal-500 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/>
              </svg>
            </div>
            <div className="content-center">
              <p className="text-sm font-bold">{notifModal.message}</p>
            </div>
          </div>
        </div>
        )}
      <div>
        {showAddModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              zIndex: 100,
            }}
          />
        )}
      </div>
      <div className="flex flex-col gap-y-2 px-4 mx-auto mb-10 max-w-screen-xl text-center md:px-8 md:text-left md:gap-y-0">
        <div className="justify-between items-start md:flex">
          <div className="max-w-lg">
            <h3 className="mt-2 text-xl font-bold text-gray-800 sm:text-2xl">
              Received amount
            </h3>
            <p className="mt-2 mb-10 text-gray-600 md:mb-2">
              Monitor your investments and see how much you have received
              already
            </p>
          </div>
          <div>
            <button
              onClick={updateAllTokens}
              className="min-w-[200px] inline-block px-4 py-2 text-white duration-150 font-medium bg-indigo-600 rounded-lg hover:bg-indigo-500 active:bg-indigo-600 md:text-sm"
            >
              Get Received Amounts
            </button>
          </div>
        </div>
        <div className="mt-3 md:mt-8 md:text-left">
          {/* <button
            className={`min-w-[200px] inline-block relative px-4 py-2 text-white duration-150 font-medium rounded-lg md:text-sm z-[200] ${
              showAddModal
                ? "bg-red-500"
                : "bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-600"
            }`}
            onClick={() => setShowAddModal(!showAddModal)}
          >
            {showAddModal ? "Close" : "Add new token"}
          </button> */}
          <button
            className={`min-w-[200px] inline-block relative px-4 py-2 text-white duration-150 font-medium rounded-lg md:text-sm ${
              showAddModal
                ? "bg-red-500"
                : "bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-600"
            }`}
            onClick={handleShowAddNewToken}
          >
            Add new token
          </button>
        </div>

        <div className="flex flex-col gap-4 mt-10 md:flex-row md:gap-0">
          <div className="flex relative self-center w-full md:self-auto md:w-3/12">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchTermChange}
              placeholder="Search..."
              className="py-2 pr-4 pl-10 w-full rounded-lg border"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="absolute top-0 bottom-0 left-3 my-auto w-6 h-6 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              style={{ pointerEvents: "none" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            {searchTerm && (
              <button
                onClick={handleClearSearchTerm}
                className="flex justify-center items-center ml-2 text-gray-500 bg-transparent border-none cursor-pointer hover:text-gray-700"
                aria-label="Clear"
              >
                <AiOutlineCloseCircle className="w-5 h-5" />
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-2 justify-center ml-4 w-fit">
          <button
              onClick={handleShowAll}
              className={`w-[120px] inline-block px-4 py-2 duration-150 font-medium rounded-lg border ${selectedTab === 'all' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}            >
              Show all
            </button>
            <button
              onClick={handleLiveDeals}
              className={`w-[120px] inline-block px-4 py-2 duration-150 font-medium rounded-lg border ${selectedTab === 'live' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}
            >
              Live deals
            </button>
            <button
              onClick={handleEndedVesting}
              className={`w-[120px] inline-block px-4 py-2 duration-150 font-medium rounded-lg border ${selectedTab === 'ended-vesting' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}            >
              Ended Vesting
            </button>
            <button
              onClick={handle50Received}
              className={`w-[120px] inline-block px-4 py-2 duration-150 font-medium rounded-lg border ${selectedTab === '50' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}            >
              50% received
            </button>
            <button
              onClick={handleEnded}
              className={`w-[120px] inline-block px-4 py-2 duration-150 font-medium rounded-lg border ${selectedTab === 'ended' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}            >
              Ended
            </button>
            <div
            className={`w-[140px] h-[42px] flex items-center duration-150 font-medium rounded-lg border ${selectedTab === 'launchpad' ? 'bg-blue-800 text-white' : 'text-indigo-500 border-indigo-600 hover:bg-indigo-600 hover:text-white active:bg-indigo-600'} text-xs`}
            >
              <select
                id="launchpad-select"
                className="m-auto bg-transparent ring-0 focus:ring-0 focus:outline-none"
                onChange={handleLaunchpadChange}
              >
                <option value="Select" disabled>
                  Launchpad
                </option>
                <option value="all">All launchpads</option>
                <option value="DAO Maker">DAO Maker</option>
                <option value="Seedify">Seedify</option>
                <option value="Infinity Pad">Infinity Pad</option>
                <option value="Direct">Direct</option>
              </select>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto mt-2 rounded-lg border shadow-sm">
          {loading && <IsLoading />}
          {!loading && (
            <table className="w-full text-sm text-left table-auto">
              <thead className="font-medium text-gray-600 bg-gray-50 border-b">
                <tr>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "ticker" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("ticker");
                      toggleSortOrder();
                    }}
                  >
                    Ticker{" "}
                    {sortBy === "ticker" && sortOrder === "asc" && (
                      <span>▲</span>
                    )}{" "}
                    {sortBy === "ticker" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "blockchain" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("blockchain");
                      toggleSortOrder();
                    }}
                  >
                    Blockchain
                    {sortBy === "blockchain" && sortOrder === "asc" && (
                      <span> ▲</span>
                    )}{" "}
                    {sortBy === "blockchain" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "toreceive" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("toreceive");
                      toggleSortOrder();
                    }}
                  >
                    Nb to receive
                    {sortBy === "toreceive" && sortOrder === "asc" && (
                      <span> ▲</span>
                    )}{" "}
                    {sortBy === "toreceive" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "received" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("received");
                      toggleSortOrder();
                    }}
                  >
                    Received
                    {sortBy === "received" && sortOrder === "asc" && (
                      <span> ▲</span>
                    )}{" "}
                    {sortBy === "received" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "pourcentage" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("pourcentage");
                      toggleSortOrder();
                    }}
                  >
                    %
                    {sortBy === "pourcentage" && sortOrder === "asc" && (
                      <span> ▲</span>
                    )}{" "}
                    {sortBy === "pourcentage" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th
                    className={`py-3 px-6 cursor-pointer text-center ${
                      sortBy === "date" ? "text-green-500" : ""
                    }`}
                    onClick={() => {
                      setSortBy("date");
                      toggleSortOrder();
                    }}
                  >
                    Vesting ends
                    {sortBy === "date" && sortOrder === "asc" && (
                      <span> ▲</span>
                    )}{" "}
                    {sortBy === "date" && sortOrder === "desc" && (
                      <span>▼</span>
                    )}
                  </th>
                  <th className="px-6 py-3 text-center">Remaining price</th>
                  <th className="px-6 py-3 text-center">Claiming portal</th>
                  <th className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody className="text-gray-600 divide-y">
                {paginatedItems.map((item, idx) => (
                  <tr
                    key={idx}
                    className={`${
                      new Date(item.vestingDate) < new Date()
                        ? "bg-red-50"
                        : ""
                    }`}
                  >
                    <td>
                      <span
                        className="flex gap-x-3 items-center px-6 py-3 align-baseline whitespace-nowrap rounded-lg cursor-pointer group"
                        onClick={() => handleShowProjectDetails(item)}
                      >
                        <img
                          src={item.logo}
                          className="w-10 h-10 rounded-full"
                          alt="logo"
                        />
                        <div>
                          <span className="block text-sm font-medium text-gray-700 capitalize group-hover:underline">
                            {item.ticker.replace("-", " ")}
                          </span>
                        </div>
                        <TokenDetails
                          token={selectedToken}
                          isVisible={showProjectDetails}
                          onClose={() => setShowProjectDetails(false)}
                        />
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center whitespace-nowrap">
                      {item.blockchain === "binance-smart-chain"
                        ? "BSC"
                        : item.blockchain === "ethereum"
                        ? "Ethereum"
                        : item.blockchain === "polygon-pos"
                        ? "Polygon"
                        : item.blockchain === "avalanche"
                        ? "Avalanche"
                        : item.blockchain === "arbitrum"
                        ? "Arbitrum"
                        : item.blockchain}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {item.to_receive?.toFixed(2)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {item.receivedAmount?.toFixed(2)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div style={{ width: 50, height: 50 }}>
                        <CircularProgressbar
                          className="text-center"
                          styles={buildStyles({
                            pathColor: "rgb(22 163 74)",
                            textColor: "rgb(22 163 74)",
                            trailColor: "white",
                            backgroundColor: "rgb(22 163 74)",
                          })}
                          value={Number(
                            (item.receivedAmount / item.to_receive) * 100
                          )}
                          text={`${Number(
                            (item.receivedAmount / item.to_receive) * 100
                          ).toFixed(2)}%`}
                        />
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div>
                        {item.vestingDate}
                      </div>
                    </td>
                    <td className="px-6 text-right whitespace-nowrap">
                      <div className="text-center">
                        <button
                          className="px-3 py-2 font-medium leading-none text-red-600 rounded-lg duration-150 hover:text-red-500 hover:bg-gray-50"
                          onClick={() => fetchPricesFunction(item.ticker)}
                        >
                          <IconUpdate />
                        </button>
                      </div>
                      <div className="font-bold text-center">
                        {isNaN(
                          fetchLivePrices[item.ticker] *
                            (item.to_receive - item.receivedAmount)
                        )
                          ? ""
                          : "$" +
                            (
                              fetchLivePrices[item.ticker] *
                              (item.to_receive - item.receivedAmount)
                            ).toFixed(2)}
                      </div>
                    </td>
                    <td className="px-6 text-right whitespace-nowrap">
                      <div className="font-bold text-center">
                      {item.claimPortal && (item.claimPortal.startsWith("http") || item.claimPortal.startsWith("www")) ? (
                          <a
                            href={item.claimPortal}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <IconLink />
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                    <td className="px-6 text-right whitespace-nowrap">
                      <EditToken
                        token={selectedToken}
                        onClose={() => setShowEditModal(false)}
                        isVisible={showEditModal}
                      />
                      {!showEditModal && (
                        <>
                          <div className="w-full">
                            <button
                              onClick={() => handleEditClick(item)}
                              className="px-3 py-2 w-1/3 font-medium leading-none text-red-600 rounded-lg duration-150 hover:text-red-500 hover:bg-gray-50"
                            >
                              <IconEdit />
                            </button>
                            <button
                              onClick={() => deleteToken(item)}
                              className="px-3 py-2 w-1/3 font-medium leading-none text-red-600 rounded-lg duration-150 hover:text-red-500 hover:bg-gray-50"
                            >
                              <IconBin />
                            </button>

                            <button
                              onClick={() => updateSingleToken(item)}
                              className="px-3 py-2 w-1/3 font-medium leading-none text-red-600 rounded-lg duration-150 hover:text-red-500 hover:bg-gray-50"
                            >
                              <IconUpdate />
                            </button>
                          </div>
                          <p className="text-xs opacity-50">
                            {" "}
                            Updated on:{" "}
                            {new Date(item.lastUpdate).toLocaleDateString(
                              "en-GB"
                            )}
                          </p>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div className="px-4 mx-auto my-8 max-w-screen-xl text-gray-600 md:px-8">
            <div className="hidden justify-end text-sm md:flex">
              <div className="flex items-center" aria-label="Pagination">
                <ul className="flex gap-1 items-center">
                  {generatePageNumbers().map((item, idx) => (
                    <li key={item}>
                      {item === "..." ? (
                        <div>{item}</div>
                      ) : (
                        <button
                          onClick={() => setCurrentPage(item)}
                          aria-current={currentPage === item ? "page" : false}
                          className={`px-3 py-2 rounded-lg duration-150 hover:text-white hover:bg-indigo-600 ${
                            currentPage === item
                              ? "bg-indigo-600 text-white font-medium"
                              : ""
                          }`}
                        >
                          {item}
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center text-sm font-medium text-gray-600 md:hidden">
          <button
            onClick={handlePrevPageMobile}
            className="px-4 py-2 rounded-lg border duration-150 hover:bg-gray-50"
          >
            Previous
          </button>
          <div className="font-medium">
            {currentPage} / {totalPages}
          </div>
          <button
            onClick={handleNextPageMobile}
            className="px-4 py-2 rounded-lg border duration-150 hover:bg-gray-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileReceived;
